import * as React from 'react';
import {useState} from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import {Alert, AlertTitle, IconButton, InputAdornment} from "@mui/material";
import axios from "axios";
import {validator} from "../utils/validator";
import Copyright from "./Copyright.jsx";
import {Visibility, VisibilityOff} from "@mui/icons-material";
import Cookies from 'js-cookie';

const theme = createTheme();

export default function ForgotPasswordSide() {
    const [apiError, setApiError] = useState({
        failed: false,
        message: ''
    });
    const [isDirty, setIsDirty] = useState([]);
    const [errors, setErrors] = useState([]);

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        setApiError({
            failed: false,
            message: ''
        });

        if ((data.get("passwordFirst") === '' || data.get("passwordSecond") === '') || (data.get("passwordFirst") !== data.get("passwordSecond"))) {
            setErrors(registerValidator({
                passwordFirst: data.get("passwordFirst"),
                passwordSecond: data.get("passwordSecond")
            }));
            return;
        }
        setErrors([]);
        axios.post(window.location.href, {
            password: data.get("passwordFirst")
        }, {
            withCredentials: true
        }).then(function (resp) {
            if (resp.status !== 200) {
                setApiError({
                    failed: true,
                    message: "Failed to register"
                });
                return
            }
            window.location.href = "/";
        }).catch(function (error) {
            setApiError({
                failed: true,
                message: error.message
            });
        });
    };

    const forgotPasswordValidator = (formData) => {
        const errors = [];
        if (!formData.username.length) errors.push('username');
        return errors;
    };

    const hasErrorUsername = errors.includes('username');


    return (
        <ThemeProvider theme={theme}>
            <Grid container component="main" sx={{height: '100vh'}}>
                <CssBaseline/>
                <Grid
                    item
                    xs={false}
                    sm={4}
                    md={7}
                    sx={{
                        backgroundImage: 'url(/background-image.jpeg)',
                        backgroundRepeat: 'no-repeat',
                        backgroundColor: (t) =>
                            t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                    }}
                />
                <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                    <Box
                        sx={{
                            my: 8,
                            mx: 4,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <h1>Reset wachtwoord</h1>
                        <Box component="form" noValidate onSubmit={handleSubmit} sx={{mt: 5}}>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="username"
                                label="Gebruikersnaam/E-Mail"
                                name="username"
                                autoComplete="username"
                                autoFocus
                                placeholder="Voer uw gebruikersnaam of e-mail in"
                                error={hasErrorUsername}
                                helperText={hasErrorUsername && 'Username is required'}
                                onChange={(e) => {
                                    let value = e.target.value;
                                    if (!isDirty.includes('username')) setIsDirty(['username', ...isDirty]);
                                    setErrors(validator(errors, 'username', value.length !== 0));
                                }}
                            />
                            {(apiError && apiError.failed) &&
                                <Alert hidden={!apiError.failed} severity="error" sx={{marginTop: '15px'}}>
                                    <AlertTitle sx={{textAlign: 'left'}}>Error</AlertTitle>
                                    {apiError.message}
                                </Alert>
                            }

                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                sx={{mt: 3, mb: 2}}
                            >
                                Wachtwoord reset aanvragen
                            </Button>
                            <Copyright sx={{mt: 5}}/>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </ThemeProvider>
    );
}
